import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { BlockWrapper } from "../Preview";
import React from "react";
import { generateCss, generateEvent, generateStyle } from "../../functions/sortableFunctions";
const CustomDot = ({ onClick, active, activeCSS, inactiveCSS, commonCSS, block, ...props }: any) => {
    return (
        <button
            type="button"
            onClick={() => onClick()}
            style={generateStyle({
                props: {
                    ...props,
                    block
                }
            })}
            className={`${generateCss({
                classes: commonCSS,
                props: props
            })} ${active ? generateCss({
                classes: activeCSS,
                props: props
            })
                :
                generateCss({
                    classes: inactiveCSS,
                    props: props
                })
                }`}
        ></button>
    )
}

const DynamicCarousel = ({
    block,
    ...props
}: any) => {
    const [loopData, setLoopData] = React.useState((props.nextJs && block?.data?.ssr) ? props?.data?.[block?.id] : null);
    const [previousData, setPreviousData] = React.useState((props.loopData || props.setLoopData || props.singleData || props.setSingleData) ? {
        ...props.previousData,
        [Object.keys(props.previousData ?? {}).length + 1]: {
            singleData: props.singleData,
            setSingleData: props.setSingleData,
            loopData: props.loopData,
            setLoopData: props.setLoopData,
        }
    } : null);

    React.useEffect(() => {
        if (!block?.data?.ssr) {
            generateEvent({
                props: {
                    ...props,
                    block
                },
                event: "onLoad",
                loopData,
                setLoopData,
                previousData,
                setPreviousData
            });
        }
    }, (block?.data?.dependencies ? eval(block.data.dependencies) : []));

    React.useEffect(() => {
        if (props.setSingleData || props.loopData || props.setLoopData || props.singleData) {
            setPreviousData(() => {

                return {
                    ...props.previousData,
                    [Object.keys(props.previousData ?? {}).length + 1]: {
                        singleData: props.singleData,
                        setSingleData: props.setSingleData,
                        loopData: props.loopData,
                        setLoopData: props.setLoopData,
                    }
                }
            });
        }
    }, [props.loopData, props.previousData, props.singleData]);
    return (
        React.createElement(
            "div",
            {
                id: block.id,
                style: generateStyle({
                    props: {
                        ...props,
                        block
                    }
                }),
                className: generateCss({
                    props: {
                        ...props,
                        block: block
                    },
                }),
                onClick: block.events?.onClick ? async (e: any) => {
                    await generateEvent({
                        props: {
                            ...props,
                            block: block
                        },
                        e: e,
                        event: "onClick"
                    });
                } : null,
                onDoubleClick: block.events?.onDoubleClick ? async (e: any) => {
                    await generateEvent({
                        props: {
                            ...props,
                            block: block
                        },
                        e: e,
                        event: "onDoubleClick"
                    });
                } : null,
                onContextMenu: block.events?.onContextMenu ? async (e: any) => {
                    await generateEvent({
                        props: {
                            ...props,
                            block: block
                        },
                        e: e,
                        event: "onContextMenu"
                    });
                } : null,
                onMouseOver: block.events?.onMouseOver ? async (e: any) => {
                    await generateEvent({
                        props: {
                            ...props,
                            block: block
                        },
                        e: e,
                        event: "onMouseOver"
                    });
                } : null,
                onMouseLeave: block.events?.onMouseLeave ? async (e: any) => {
                    await generateEvent({
                        props: {
                            ...props,
                            block: block
                        },
                        e: e,
                        event: "onMouseLeave"
                    });
                } : null
            },
            <Carousel
                responsive={{
                    base: {
                        breakpoint: { max: 425, min: 0 },
                        items: block.data?.responsive?.base?.items ?? 1,
                        slidesToSlide: block.data?.responsive?.base?.slidesToSlide ?? 1
                    },
                    xs: {
                        breakpoint: { max: 640, min: 425 },
                        items: block.data?.responsive?.xs?.items ?? 1,
                        slidesToSlide: block.data?.responsive?.xs?.slidesToSlide ?? 1
                    },
                    sm: {
                        breakpoint: { max: 768, min: 640 },
                        items: block.data?.responsive?.sm?.items ?? 1,
                        slidesToSlide: block.data?.responsive?.sm?.slidesToSlide ?? 1
                    },
                    md: {
                        breakpoint: { max: 1024, min: 768 },
                        items: block.data?.responsive?.md?.items ?? 1,
                        slidesToSlide: block.data?.responsive?.md?.slidesToSlide ?? 1
                    },
                    lg: {
                        breakpoint: { max: 1280, min: 1024 },
                        items: block.data?.responsive?.lg?.items ?? 1,
                        slidesToSlide: block.data?.responsive?.lg?.slidesToSlide ?? 1
                    },
                    xl: {
                        breakpoint: { max: 1536, min: 1280 },
                        items: block.data?.responsive?.xl?.items ?? 1,
                        slidesToSlide: block.data?.responsive?.xl?.slidesToSlide ?? 1
                    },
                    '2xl': {
                        breakpoint: { max: 9999, min: 1536 },
                        items: block.data?.responsive?.['2xl']?.items ?? 1,
                        slidesToSlide: block.data?.responsive?.['2xl']?.slidesToSlide ?? 1
                    }
                }}
                containerClass={`${generateCss({
                    props: {
                        ...props,
                        block: block
                    },
                })} !w-full !p-0 !m-0 !border-0  !shadow-none !transform-none !animate-none !bg-none !bg-transparent !h-full !max-w-none !min-w-0`}
                itemClass={generateCss({
                    classes: block.data?.itemClass,
                    props: props
                })}
                sliderClass={generateCss({
                    classes: block.data?.sliderClass,
                    props: props
                })}
                dotListClass={generateCss({
                    classes: block.data?.dotListClass,
                    props: props
                })}
                removeArrowOnDeviceType={block.data.removeArrowOnDeviceType ?? []}
                autoPlaySpeed={block.data?.autoPlaySpeed ?? 3000}
                slidesToSlide={block.data?.slidesToSlide ?? 1}
                draggable={block.data?.draggable ?? true}
                swipeable={block.data?.swipeable ?? true}
                arrows={block.data?.arrows ?? true}
                showDots={block.data.showDots ?? false}
                autoPlay={block.data.autoPlay ?? false}
                infinite={block.data.infinite ?? false}
                keyBoardControl={block.data?.keyBoardControl ?? true}
                renderDotsOutside={block.data?.renderDotsOutside ?? false}
                centerMode={block.data?.centerMode ?? false}
                rtl={block.data?.rtl ?? false}


                customLeftArrow={block.children?.[1] ?
                    <BlockWrapper
                        {...props}
                        block={block.children[1]}
                    />
                    :
                    null
                }
                customRightArrow={block.children?.[2] ?
                    <BlockWrapper
                        {...props}
                        block={block.children[2]}
                    />
                    :
                    null
                }
                customDot={block.data?.customDot ?
                    <CustomDot
                        {...props}
                        block={block}
                        activeCSS={block.data?.customDot?.activeCSS}
                        inactiveCSS={block.data?.customDot?.inactiveCSS}
                        commonCSS={block.data?.customDot?.commonCSS}
                    />
                    :
                    null
                }
            >
                {
                    (Array.isArray(loopData) ? loopData : [])?.slice(0, block?.data?.numberOfItemsToDisplay)?.map((singleData, index): any => {
                        if (block?.data?.filter ? eval(block?.data?.filter) : true) {
                            return <BlockWrapper
                                {...props}
                                key={index}
                                block={block?.children?.[0]}
                                previousData={previousData}
                                loopData={loopData}
                                setLoopData={setLoopData}
                                singleData={singleData}
                            />
                        }
                    })
                }
            </Carousel>
        )
    );
}

export default DynamicCarousel;